/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

@Component({
  standalone: true,
  selector: 'app',
  imports: [UIRouterModule],
  template: '<ui-view></ui-view>'
})
export class AppComponent {
}
